module.exports = __webpack_public_path__ + "img/logo2.370d067b.png";